import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { g } from '../global-constants';

const ResultsHeading = ({ label, labelSize = 5, ariaLabelledById }) => {
	const { display } = usePrefs();
	const labelAttributes = {
		id: ariaLabelledById,
		...(display === g.EMBEDDED && { className: 'widget-heading' })
	};
	return React.createElement(`h${labelSize}`, labelAttributes, label);
};

ResultsHeading.propTypes = {
	label: PropTypes.string.isRequired,
	ariaLabelledById: PropTypes.string.isRequired,
	labelSize: PropTypes.number
};

export default ResultsHeading;
